import React from 'react';
import FromTo from './FromTo';
import _ from 'lodash';

/**
 * 
 * @param {import('./FromTo').FromToProps} props 
 * @returns 
 */
function BunkerPlace(props) {
    const selectPortCustom = async (port) => {
        props.changeFieldsMultiple([
            {
                index: props.countIndex,
                field: props.field,
                value: _.pick(port, ['_id', 'name', 'areaParent']),
            },
        ]);
    };

    return (
        <FromTo
            {...props}
            selectPortCustom={selectPortCustom}
        />
    );
}

export default React.memo(BunkerPlace);



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/BunkerPlace.jsx